import { Pipe, PipeTransform } from '@angular/core';

/**
 * Renders a sensitive identifier (account number, IBAN, card PAN, phone)
 * with all but the last `revealCount` characters replaced by a bullet.
 *
 * Defaults: mask everything, reveal the last 4. A `null`/`undefined`/empty
 * input renders an empty string so templates can use it on optional values
 * without `*ngIf` guards.
 *
 * Usage in templates:
 *   {{ accountNumber | maskedDisplay }}              // ••••1234
 *   {{ iban | maskedDisplay:4:'•' }}                 // explicit
 *   {{ iban | maskedDisplay:4:'•':'-' }}             // separator every 4 chars
 */
@Pipe({
  name: 'maskedDisplay',
  standalone: true,
  pure: true,
})
export class MaskedDisplayPipe implements PipeTransform {
  transform(
    value: string | number | null | undefined,
    revealCount = 4,
    maskChar = '•',
    separator = '',
  ): string {
    if (value == null) {
      return '';
    }
    const str = String(value);
    if (str.length === 0) {
      return '';
    }
    if (str.length <= revealCount) {
      return str;
    }
    const visible = str.slice(-revealCount);
    const maskedLength = str.length - revealCount;
    let masked = maskChar.repeat(maskedLength) + visible;
    if (separator) {
      masked = masked.match(/.{1,4}/g)?.join(separator) ?? masked;
    }
    return masked;
  }
}
